export var AttachmentFileType;

(function (AttachmentFileType) {
  AttachmentFileType["PDF_DOCUMENT"] = "PDF_DOCUMENT";
  AttachmentFileType["WORD_DOCUMENT"] = "WORD_DOCUMENT";
  AttachmentFileType["SPREADSHEET"] = "SPREADSHEET";
  AttachmentFileType["IMAGE"] = "IMAGE";
  AttachmentFileType["WEB_LINK"] = "WEB_LINK";
  AttachmentFileType["FILE"] = "FILE";
})(AttachmentFileType || (AttachmentFileType = {}));